export function viewCertificate(url) {
  const element = document.createElement('a');
  element.href = url;
  element.target = '_blank';
  element.click();
}
